import { render } from "./ProjectAssessmentDashboard.vue?vue&type=template&id=426db0c4&scoped=true"
import script from "./ProjectAssessmentDashboard.vue?vue&type=script&lang=js"
export * from "./ProjectAssessmentDashboard.vue?vue&type=script&lang=js"

import "./ProjectAssessmentDashboard.vue?vue&type=style&index=0&id=426db0c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-426db0c4"]])

export default __exports__